import * as React from 'react';
import { observer } from 'mobx-react';
import { ITagsListParams } from './ITagsListParams';
import { ParameterHelper } from 'MeasurementsCalculations';

@observer
export class TagsList extends React.Component<ITagsListParams> {
  constructor(props: ITagsListParams) {
    super(props, undefined);
  }

  render() {
    let additionalClass = this.props.className ? this.props.className : '';
    let addIsSelectedClass = this.props.measurementGroup.isSelected ? 'isSelected' : '';
    let lengthToTargetValue = ParameterHelper.getParameterValueFromGroup(
      this.props.measurementGroup,
      'LengthToTarget',
      this.props.unitPresentation
    );
    let lengthToTargetUnit = ParameterHelper.getParameterUnit(
      'LengthToTarget',
      this.props.unitPresentation
    );
    return (
      <span className={`TagsList tags-list ${addIsSelectedClass} ${additionalClass}`}>
        {this.props.measurementGroup.lengthToTarget && (
          <span className="group-tag">
            {lengthToTargetValue}
            {lengthToTargetUnit}
          </span>
        )}
        {!this.props.measurementGroup.lengthToTarget &&
          this.props.measurementGroup?.tagsTitle !== '' && (
            <span className="group-tag" data-bind="text: measurementGroup.tagsTitle">
              {this.props.measurementGroup.tagsTitle}
            </span>
          )}
        {!this.props.measurementGroup.lengthToTarget &&
          this.props.measurementGroup?.tagsTitle === '' && (
            <span className="group-tag" data-bind="text: clubType">
              {this.props.measurementGroup.clubType}
            </span>
          )}
      </span>
    );
  }
}
